import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import LegalLink from 'components/LegalLink';
import { withRouter } from 'react-router';
import portalLogo from 'images/srm_portal_logo_full.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { hasAuthenticated } from 'reducers/auth';

const AuthStyling = ({
  children,
  message,
  className,
  history,
  dataTestid,
  navigateToHome,
}) => {
  const { t } = useTranslation();
  const authenticated = useSelector(state => hasAuthenticated(state));
  /* eslint multiline-comment-style: ["error", "starred-block"] */
  /*
   * Warning: React does not recognize the `navigateToHome` prop on a DOM element.
   *If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `navigatetohome` instead.
   *If you accidentally passed it from a parent component, remove it from the DOM element
   */
  const navigatetohome = () => {
    if (authenticated) {
      return history.push('/');
    } else {
      return history.push('/login');
    }
  };
  return (
    <div className={styles.alignCenter} data-testid={dataTestid}>
      <div className={styles.mainForm}>
        <div className={styles.formLogo}>
          <img
            className={styles.logo}
            alt="xx"
            src={portalLogo}
            {...(navigateToHome && { onClick: navigatetohome })}
          />
          <p className={styles.welcomeMessage}>{t(message)}</p>
        </div>
        {navigateToHome
          ? React.Children.map(children, el => {
              // this will ensure all the children are passed with navigatetohome prop
              return React.cloneElement(el, {
                navigatetohome,
              });
            })
          : children}

        <LegalLink className={className} />
      </div>
    </div>
  );
};

export default withRouter(AuthStyling);
AuthStyling.defaultProps = {
  navigateToHome: true,
};
AuthStyling.propTypes = {
  history: PropTypes.object.isRequired,
  message: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  className: PropTypes.string,
  dataTestid: PropTypes.string,
  navigateToHome: PropTypes.bool,
};
